import select from 'dom-select';

export const GlobalSignin = (el) => {
  const ui = {
    el,
    selector: select('#global-signin-select'),
    container: select('.global-signin'),
    mobileTrigger: select('#signin-modal-1'),
    desktopTrigger: select('.navigation__signin')
  };

  const addEvents = () => {
    ui.selector.addEventListener('change', () => {
      const thisVal = ui.selector.value;

      switch (thisVal) {
        case 'A':
          ui.container.classList.remove('global-signin--business');
          ui.container.classList.add('global-signin--personal');
          break;
        case 'B':
          ui.container.classList.remove('global-signin--personal');
          ui.container.classList.add('global-signin--business');
          break;
        case 'https://onlinebanking.firstdata.com/ecs/auth/?cid=AAAA4422001':
          window.location.assign('https://onlinebanking.firstdata.com/ecs/auth/?cid=AAAA4422001');
          break;
        case 'https://www.depositorcontrol.com/':
          window.location.assign('https://www.depositorcontrol.com/');
          break;
        }
    });

    ui.mobileTrigger.addEventListener('click', () => {
      ui.desktopTrigger.click();
    });
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default GlobalSignin;
